// Per-round rules (§18.6): TUNE defaults, then the round's mutator, then the item pool.
import { TUNE } from '../constants';
import { ItemKind, ModeId, MutatorId } from '../ids';
import type { RoundConfig, RoundRules } from '../types';

const FULL_POOL: readonly ItemKind[] = [ItemKind.BANANA, ItemKind.BOMB, ItemKind.GLOVE, ItemKind.BALLOON, ItemKind.PLUNGER, ItemKind.SHAKE];

export function buildRules(cfg: RoundConfig): RoundRules {
  const r: RoundRules = {
    accel: TUNE.bean.accel,
    decel: TUNE.bean.decel,
    gravity: TUNE.jump.gravity,
    jumpVz: TUNE.jump.vz,
    kbMult: 1,
    dizzyGainMult: 1,
    crateMin: TUNE.crate.minInterval,
    crateMax: TUNE.crate.maxInterval,
    crateMaxCount: TUNE.crate.maxCount,
    itemPool: cfg.modeId === ModeId.HOT_POTATO ? [...TUNE.potato.itemPool] : [...FULL_POOL],
    bombOnlyCrates: false,
  };

  switch (cfg.mutator) {
    case MutatorId.BUTTER_FLOOR:
      r.accel = TUNE.mutators.butterFloor.accel;
      r.decel = TUNE.mutators.butterFloor.decel;
      break;
    case MutatorId.FLOATY:
      r.gravity = TUNE.mutators.floaty.gravity;
      r.jumpVz = TUNE.mutators.floaty.jumpVz;
      r.kbMult = TUNE.mutators.floaty.kbMult;
      break;
    case MutatorId.BOMB_PARTY:
      r.bombOnlyCrates = true;
      r.crateMin = TUNE.mutators.bombParty.crateMin;
      r.crateMax = TUNE.mutators.bombParty.crateMax;
      r.crateMaxCount = TUNE.mutators.bombParty.crateMaxCount;
      break;
    case MutatorId.DOUBLE_DIZZY:
      r.dizzyGainMult = TUNE.mutators.doubleDizzy.dizzyGainMult;
      break;
    default:
      break;
  }

  if (!cfg.itemsOn) r.itemPool = [];
  return r;
}
